<template>
	<div style="padding: 10px">
		<!--
		<div class="badge badge-pill badge-danger" v-if="notificationCount">
			{{ $tc('n-new-messages', this.notificationCount) }}
		</div>
		-->
		<div style="height: 300px; overflow: auto; display: flex; flex-direction: column-reverse;">
			<div>
				<div v-for="message in messages" :key="message.message_id">
					<div 
						class="chat-message"
						:class="{'chat-message-in': (message.fromuser_id != $UserSession.getValue('id')), 'chat-message-out': (message.fromuser_id == $UserSession.getValue('id'))}"
					>
						<strong v-if="message.fromuser_id != $UserSession.getValue('id')">{{message.DisplayName}}<br/></strong>
						{{message.message_content}}
					</div>
				</div>
			</div>
		</div>
		<div>
			<label class="text-sm mb-1">{{ $t('new-message') }}</label>
			<select
				v-model="recipient"
				aria-label="Recipient"
				class="form-control mb-2"
			>
				<option
					v-for="option in recipientOptions"
					:key="option.user_id"
					:value="Number(option.user_id)"
					:aria-label="option.user_displayName"
				>{{ option.user_displayName }}</option>
			</select>
			<textarea-autosize
				class="form-control align-top mb-2"
				aria-label="Message"
				v-model="newMessage"
			></textarea-autosize>
			<button class="btn btn-primary btn-block" @click="sendMessage" :disabled="(!recipient || !newMessage)">Send</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OSCEChat',
	
    mounted() {
    	this.getRecipientOptions()
    	this.updateMessages()
    },
    
    props: {
    	canCleanUpNotifications: {
    		type: Boolean,
    		default: false 
    	}
    },
	
	data() {
		return {
			messages: [] ,
			notificationCount: 0 ,
			recipientOptions: [],
			newMessage: '',
			recipient: 0
		};
	},
	
	computed: {
		latestNotification() {
			return this.$store.state.latestNotification
		}
	},
	
	watch: {
		latestNotification: {
			handler() {
				this.notificationCount = this.$store.getters.notificationCount
				this.updateMessages(),
				this.$emit('new-message', this.notificationCount);
			},
			deep: true,	 // Add this if notification is an object
			immediate: false
		},
	},
	
	methods: {
		getRecipientOptions() {
				
			this.$cfetch(`${this.$settings.APIBaseURL}/osce/getmessageableusers`,
				{
					method: "get"
				}
			)
				.then(json => {
					if (json.status == "SUCCESS") {
						this.recipientOptions = json.results
					} else {
						this.$store.commit("openDialog", this.$t("could-not-send-message"));
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
		},
		updateMessages() {
			this.$cfetch(`${this.$settings.APIBaseURL}/messages/list`, {
				ignoreauthfailed: true,
				data: {
					//recent: 1
					include_sent: 1
				}
			})
			.then(json => {
				if (json.status.toLowerCase() === "success") {
					this.messages = json.messages.reverse();
					
					if(this.canCleanUpNotifications){
						this.markAllRead();
					}
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		},
		sendMessage() {
		
			if(!this.recipient){
				this.$store.commit("openDialog", this.$t("no-recipients-specified"))
				return
			}
		
			if(!this.newMessage){
				this.$store.commit("openDialog", this.$t("no-message-specified"))
				return
			}
			
			var data = {
					message: {
						subject: '',
						content: this.newMessage,
						to: [
							this.recipient
						],
						important: 1
					} ,
					no_email: 1
				}
			/*
			if(this.$route.params.threadid) {
				data.thread_id = this.$route.params.threadid
			}
			if(this.$route.query.replyto) {
				data.replyto = this.$route.query.replyto;
			}
			*/

			this.newMessage = '';
			
			this.$cfetch(`${this.$settings.APIBaseURL}/messages/send`,
				{
					method: "post",
					data
				}
			)
			.then(json => {
				if (json.status == "SUCCESS") {
					/*
					this.$store.commit("openDialog", {
						title: this.$t("message-sent"),
						content: this.$t("your-message-has-been-sent"),
						cypressId: "message-sent",
						confirmCallBack: function() {
							this.$router.replace("/messages/list");
						}
					});
					*/
					this.updateMessages();
				} else {
					this.$store.commit("openDialog", this.$t("could-not-send-message"));
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit("openDialog", this.$t("could-not-send-message"));
			});
		},
		markAllRead() {
			this.$cfetch(`${this.$settings.APIBaseURL}/messages/read`,
				{
					method: "post",
					data: {
						lessthan: this.messages[this.messages.length - 1].message_id
					}
				}
			)
			.then(json => {
				if (json.status == "SUCCESS") {
					this.notificationCount = 0;
					this.$emit('new-message', this.notificationCount);
				} 
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		}
	}
}
</script>

<style>
.chat-message {
  width: 75%;
  border-radius: 10px;
  padding: .5em;
  margin-bottom: .5em;
  font-size: .8em;

}
.chat-message-out {
  background: #407FFF;
  color: white;
  margin-left: 25%;
}
.chat-message-in {
  background: #F1F0F0;
  color: black;
}
.chat-inputs {
  display: flex;
  justify-content: space-between;
}
</style>